import IndividualsJobsDirectories from 'pages/individuals-jobs'
export default IndividualsJobsDirectories
